import React from 'react';
import { useTranslation } from 'react-i18next';

interface TabsProps {
  types: string[];
  activeTab: string;
  onTabChange: (tab: string) => void;
  loading?: boolean;
}

const Tabs: React.FC<TabsProps> = ({ types, activeTab, onTabChange, loading }) => {
  const { t } = useTranslation('home');

  const formatTabName = (type: string) => {
    if (type === 'all') return t('all_products');
    // Capitalize first letter and replace underscores with spaces
    return type
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  if (loading) {
    return (
      <div className="container mx-auto px-4 py-6">
        <div className="flex flex-wrap gap-2 md:gap-4">
          {[...Array(4)].map((_, i) => (
            <div
              key={i}
              className="h-10 w-24 md:w-32 bg-gray-200 rounded-lg animate-pulse"
            />
          ))}
        </div>
        <div className="mt-6 border-b-2 border-gray-200"></div>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-6">
      {/* Tabs */}
      <div className="flex flex-wrap gap-2 md:gap-4 justify-start md:justify-start">
        {types.map((type) => (
          <button
            key={type}
            onClick={() => onTabChange(type)}
            className={`px-4 py-2 md:px-6 md:py-3 rounded-lg font-medium transition-all whitespace-nowrap text-sm md:text-base ${
              activeTab === type
                ? 'bg-primary text-white shadow-lg'
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
            }`}
          >
            {formatTabName(type)}
          </button>
        ))}
      </div>

      {/* Divider */}
      <div className="mt-6 border-b-2 border-gray-200"></div>
    </div>
  );
};

export default Tabs;
